(function(){
  const STEP = 200;

  function initSiblingSlider(container){
    if (!container) return;

    // Always enforce horizontal scroll
    container.classList.add('sibling-products');
    container.classList.remove('flex-wrap'); // remove wrapping if re-added

    if (container.dataset.sliderReady) return;
    container.dataset.sliderReady = "true";

    const wrap = container.parentNode;
    wrap.classList.add('sibling-slider-wrap');

    // arrows
    const left = document.createElement('button');
    left.className = 'sibling-arrow sibling-arrow--left';
    left.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>';

    const right = document.createElement('button');
    right.className = 'sibling-arrow sibling-arrow--right';
    right.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 6l6 6-6 6"/></svg>';

    wrap.appendChild(left);
    wrap.appendChild(right);

    left.addEventListener("click", ()=> container.scrollBy({left:-STEP, behavior:"smooth"}));
    right.addEventListener("click",()=> container.scrollBy({left: STEP, behavior:"smooth"}));

    function updateArrows(){
      const max = container.scrollWidth - container.clientWidth;
      left.style.display  = container.scrollLeft <= 0 ? "none" : "grid";
      right.style.display = container.scrollLeft >= max ? "none" : "grid";
    }
    container.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function initAll(){
    document.querySelectorAll('.flex.gap-2.mt-2.relative.flex-wrap, .sibling-products').forEach(initSiblingSlider);
  }

  // run once
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // observe DOM for re-renders (Alpine/Shopify changes)
  const mo = new MutationObserver(()=> initAll());
  mo.observe(document.body, {childList:true, subtree:true});
})();
